export default {
  pageTitle: "Hilfe & Support",
  pageDescription: "Antworten finden oder eine Supportanfrage senden",
  myTickets: "Meine Tickets",
  sections: {
    faqTitle: "Häufig gestellte Fragen",
    faqDescription: "Häufige Fragen zur Plattform durchsuchen",
    ticketTitle: "Support-Ticket senden",
    ticketDescription:
      "Beschreiben Sie Ihr Anliegen und unser Team meldet sich per E-Mail bei Ihnen",
  },
  needHelp: {
    title: "Nicht gefunden, wonach Sie suchen?",
    description:
      "Unser Support-Team hilft Ihnen gerne weiter. Senden Sie ein Ticket und wir antworten so schnell wie möglich.",
    action: "Ticket senden",
  },
  tabs: {
    faq: "FAQ",
    faqDesc: "Antworten auf häufige Fragen finden",
    ticket: "Ticket senden",
    ticketDesc: "Probleme melden oder Hilfe anfordern",
  },
  faqSearchPlaceholder: "Fragen und Antworten durchsuchen",
  faqAll: "Alle",
  faqNone: "Keine FAQs für diese Kategorie gefunden",
  ticketForm: {
    requestTypeLabel: "Um welche Art von Anfrage handelt es sich?",
    requestTypeHint:
      "Wählen Sie die Option, die Ihr Anliegen am besten beschreibt",
    priorityLabel: "Priorität",
    priorityHint: "Wie dringend ist dieses Problem für Ihr Geschäft?",
    subjectLabel: "Betreff",
    subjectPlaceholder: "Kurze Beschreibung Ihres Problems",
    messageLabel: "Nachricht",
    messagePlaceholder: "Beschreiben Sie Ihr Problem im Detail…",
    attachmentsLabel: "Anhänge",
    attachmentsHint:
      "Dateien hier ablegen oder zum Hochladen klicken (max. 20 MB pro Datei)",
    addFiles: "Dateien hinzufügen",
    submit: "Ticket senden",
    fileTooLarge: "{{name}} ist zu groß. Maximale Größe: {{max}}.",
    fileUnsupported: "{{name}} ist kein unterstützter Dateityp.",
    toastSelectCategory: "Bitte wählen Sie eine Kategorie",
    toastEnterSubject: "Bitte geben Sie einen Betreff ein",
    toastEnterMessage: "Bitte geben Sie eine Nachricht ein",
    toastSubmitted: "Ticket gesendet! Wir melden uns in Kürze bei Ihnen.",
    toastSubmitFailed:
      "Ticket konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    toastAttachmentsFailed:
      "Ticket erstellt, aber die Anhänge konnten nicht hochgeladen werden. Sie können sie auf der Ticketseite hinzufügen.",
    categories: {
      problem: "Problem",
      suggestion: "Vorschlag",
      improvement: "Verbesserung",
      question: "Frage",
      billing: "Abrechnung",
    },
    priorities: {
      critical: "Kritisch",
      high: "Hoch",
      medium: "Mittel",
      normal: "Normal",
      low: "Niedrig",
    },
    respondLine: "Wir antworten an {{email}}",
  },
  list: {
    title: "Meine Tickets",
    description: "Ihre Supportanfragen anzeigen und verwalten",
    backToSupport: "Hilfe & Support",
    newTicket: "Neues Ticket",
    createTicket: "Ticket erstellen",
    searchPlaceholder: "Tickets nach Betreff oder Nummer suchen…",
    loadingTickets: "Tickets werden geladen…",
    loadError: "Tickets konnten nicht geladen werden",
    noTicketsFound: "Keine Tickets gefunden",
    tryAdjusting: "Passen Sie Ihre Suche oder Filter an",
    createFirstHint: "Erstellen Sie Ihr erstes Ticket, um Hilfe zu erhalten",
    lastActivityShort: "Zuletzt: {{when}}",
    replyNeeded: "Antwort erforderlich",
    messageCountPlain: "{{count}}",
    stats: {
      ongoing: "Aktiv",
      filterLabel: "Ticketstatus",
      total: "Alle",
    },
  },
  adminList: {
    searchPlaceholder: "Suche nach Ticketnummer, Betreff oder Verkäufer…",
    filterAny: "Beliebig",
    priority: "Priorität",
    category: "Kategorie",
    ticketsFound_one: "{{count}} Ticket gefunden",
    ticketsFound_other: "{{count}} Tickets gefunden",
    loadingTickets: "Tickets werden geladen…",
    noTicketsFound: "Keine Tickets gefunden",
    tryAdjusting: "Passen Sie Ihre Filter an",
    allCaughtUp: "Alles erledigt!",
    clearFilters: "Filter zurücksetzen",
  },
  sidebar: {
    seller: "Verkäufer",
    unknownSeller: "Unbekannter Verkäufer",
    sendEmail: "E-Mail senden",
    openProfile: "Profil öffnen",
    statusAndPriority: "Status & Priorität",
    status: "Status",
    priority: "Priorität",
    details: "Details",
    category: "Kategorie",
    created: "Erstellt",
    lastUpdated: "Zuletzt aktualisiert",
    resolved: "Gelöst",
    messages: "Nachrichten",
    messagesTotal: "{{count}} gesamt",
    quickActions: "Schnellaktionen",
    markAsResolved: "Als gelöst markieren",
    closeTicket: "Ticket schließen",
    reopenTicket: "Ticket wiedereröffnen",
  },
  adminDetail: {
    loadingTicket: "Ticket wird geladen…",
    notFound: "Ticket nicht gefunden",
    backToTickets: "Zurück zu Tickets",
    ticketDetails: "Ticketdetails",
    openedOn: "Eröffnet am {{date}}",
    messagesCount: "{{count}} Nachrichten",
    replyPlaceholder: "Antwort eingeben (E-Mail wird an Verkäufer gesendet)…",
    ticketClosed: "Dieses Ticket ist geschlossen.",
    reopenTicket: "Ticket wiedereröffnen",
  },
  messageInput: {
    modeLabel: "Nachrichtentyp",
    defaultPlaceholder: "Nachricht eingeben…",
    internalNotePlaceholder: "Interne Notiz hinzufügen…",
    replyToPartner: "An Verkäufer antworten",
    internalNote: "Interne Notiz",
    internalNoteWarning: "Interne Notizen sind nur für Staff sichtbar",
    attach: "Anhängen",
    fileTooLarge: "{{name}} ist zu groß. Maximale Größe: {{max}}.",
    fileUnsupported: "{{name}} ist kein unterstützter Dateityp.",
    addNote: "Notiz hinzufügen",
    send: "Senden",
  },
  messageBubble: {
    internalNote: "Interne Notiz",
    supportTeam: "Support-Team",
    you: "Sie",
    sellerFallback: "Verkäufer",
  },
  detail: {
    messageSent: "Nachricht gesendet!",
    sendMessageError: "Nachricht konnte nicht gesendet werden",
    loadingTicket: "Ticket wird geladen…",
    notFound: "Ticket nicht gefunden",
    backToTickets: "Zurück zu Tickets",
    conversationEmpty:
      "Noch keine Nachrichten. Starten Sie die Konversation unten.",
    messagesCount_one: "{{count}} Nachricht",
    messagesCount_other: "{{count}} Nachrichten",
    messagePlaceholder: "Nachricht eingeben…",
    resolvedTitle: "Dieses Ticket wurde gelöst",
    resolvedNeedHelp: "Benötigen Sie weitere Hilfe?",
    openNewTicket: "Neues Ticket eröffnen",
    openedOn: "Eröffnet am {{date}}",
    replyNeededTitle: "Das Support-Team hat geantwortet",
    replyNeededDescription:
      "Lesen Sie die neueste Nachricht unten und senden Sie Ihre Antwort, um das Ticket offen zu halten.",
  },
  adminHub: {
    ticketsTab: "Support-Tickets",
    ticketsDescription: "Partner-Support-Tickets verwalten",
    chatsTab: "Kunden-Support-Chats",
    chatsDescription: "Kunden-Support-Chats verwalten",
  },
  customerSupportChats: {
    searchPlaceholder: "Suche nach Kontakt…",
    loading: "Chats werden geladen…",
    loadingChat: "Konversation wird geladen…",
    empty: "Keine Kunden-Support-Chats entsprechen diesem Filter",
    emptyOpen: "Keine offenen Kunden-Support-Chats",
    statusFilter: "Status",
    filterOpen: "Offen",
    filterClosed: "Geschlossen",
    filterAll: "Alle",
    closedBadge: "Geschlossen",
    selectChat: "Wählen Sie einen Chat, um die Konversation anzuzeigen",
    noMessages: "Noch keine Nachrichten",
    guest: "Gast",
    registeredCustomer: "Registrierter Kunde",
    replyPlaceholder: "An Kunden antworten…",
    chatClosed: "Dieser Chat ist geschlossen.",
    closeChat: "Chat schließen",
    closed: "Chat geschlossen",
    recentBookings: "Aktuelle Buchungen",
    noBookings: "Keine Buchungen für diesen Kontakt gefunden",
    lastHandshakeBadge: "Letzter Handshake",
    openBooking: "Öffnen",
    amend: "Ändern",
    reopenHandshake: "Handshake wiedereröffnen",
    cancelBooking: "Stornieren",
    amendTitle: "Buchungsdatum/-zeit ändern",
    visitDateLabel: "Besuchsdatum",
    visitTimeLabel: "Besuchszeit",
    overrideCapacity: "Kapazitäts-/Fristwarnungen überschreiben",
    amendConfirm: "Änderung speichern",
    amendSuccess: "Buchung geändert",
    cancelTitle: "Buchung stornieren",
    cancelDescriptionWithDetails:
      "Cancel the booking for {{name}} ({{activity}})? Confirm amount on the booking detail if needed. Refunds start automatically and cannot be undone.",
    refundChoiceLabel: "Erstattungsrichtlinie",
    refundDefault: "Erstatten innerhalb der Frist, sonst keine Erstattung",
    refundForce: "Immer erstatten",
    refundNone: "Nie erstatten (bei Zahlung als erfüllt abrechnen)",
    cancelConfirm: "Stornierung bestätigen",
    cancelSuccess: "Buchung storniert",
    reopenSuccess: "Handshake wiedereröffnet; dieser Chat wurde geschlossen",
    reopenConfirmTitle: "Handshake wiedereröffnen?",
    reopenConfirmMessage:
      "Der Support-Chat wird geschlossen und der Handshake wiedereröffnet, damit der Partner die Buchung im Chat ändern kann.",
    reopenConfirm: "Handshake wiedereröffnen",
    cancelForceConfirmTitle: "Stornierung mit Überschreibung bestätigen?",
    cancelForceRefundMessage:
      "Sie haben „Immer erstatten“ gewählt. Dies überschreibt die Rückerstattungsfrist-Richtlinie und kann von diesem Bildschirm aus nicht rückgängig gemacht werden.",
    cancelForceNoneMessage:
      "Sie haben „Nie erstatten“ gewählt. Bezahlte Buchungen können als erfüllt abgerechnet werden, ohne Erstattung an den Kunden.",
  },
} as const;
